/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://ugxt7gjxtfd77kkv563flvckwu.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-3ldoq533d5auboiuxqimcwy25e",
    "aws_cognito_identity_pool_id": "us-west-2:bb7cbd21-5979-47c4-b7c7-f6d04cf67b8a",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_5fOHN3qgD",
    "aws_user_pools_web_client_id": "5kbsven74k51pslsh0cmubapii",
    "oauth": {}
};


export default awsmobile;
